<footer>
  <div class="privacy_policy_ftr">
    <a target="_blank" (click)="openPrivacyPolicyDialog()">Privacy Policy</a>
  </div>
  <div class="copyright">&#169; 2018 Copyright Sami Valkonen | All Rights Reserved</div>
</footer>

<div class="cookiesPopup" *ngIf="cookiesPopupVisible === true">
  <div class="CookiePopupContentText">
    We use cookies to ensure the best experience on our website. If you use this webpage we assume that you accept our
    privacy policy.
  </div>
  <div class="CookiesPopupContentButtons">
    <div class="CookiesPopupContentButton">
      <button mat-raised-button color="primary" (click)="acceptPrivacyPolicy()">Accept</button>
    </div>
    <div class="CookiesPopupContentButton">
      <button mat-raised-button color="primary" (click)="openPrivacyPolicyDialog()">Read More</button>
    </div>
  </div>
</div>
